import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';

// refer to MUI documentations for prop values
export const StyledFlexContainer = (props) => {
  return <Box {...props} />;
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection === undefined ? 'row' : props.flexDirection)};
  flex-wrap: wrap;
  align-items: ${(props) => props.AlignItems};
  height: 100%;
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.columnReverse ? 'column-reverse' : 'column')};
  flex-grow: ${(props) => (props.columnReverse ? '1' : props.flexGrow)};
  flex-wrap: wrap;
  justify-content: ${(props) =>
    props.justifyContent === undefined ? 'flex-start' : props.justifyContent};
  align-items: ${(props) => (props.alignItems === undefined ? 'flex-start' : props.alignItems)};
  align-content: ${(props) =>
    props.alignContent === undefined ? 'flex-start' : props.alignContent};
  gap: ${(props) => (props.gap === undefined ? '' : props.gap)};
  row-gap: ${(props) => (props.rowGap === undefined ? '' : props.rowGap)};
`;

export const VerticalContainerItems = styled.div`
  flex-grow: ${(props) => (props.flexGrow === undefined ? 'auto' : props.flexGrow)};
  margin: ${(props) => (props.margin === undefined ? '' : props.margin)};
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.rowReverse ? 'row-reverse' : 'row')};
  flex-wrap: ${(props) => (props.wrap === undefined ? 'wrap' : props.wrap)};
  justify-content: ${(props) =>
    props.justifyContent === undefined ? 'flex-start' : props.justifyContent};
  align-items: ${(props) => (props.alignItems === undefined ? 'flex-start' : props.justifyContent)};
  align-content: ${(props) =>
    props.alignContent === undefined ? 'flex-start' : props.alignContent};
  gap: ${(props) => (props.gap === undefined ? '' : props.gap)};
  column-gap: ${(props) => (props.columnGap === undefined ? '' : props.columnGap)};
`;

export const HorizontalContainerItems = styled.div`
  flex-grow: ${(props) => (props.flexGrow === undefined ? 'auto' : props.flexGrow)};
`;
